import { trpc } from '@/lib/trpc';

interface TenantLogoProps {
  className?: string;
  fallbackSrc?: string;
}

/**
 * TenantLogo component that displays the logo from tenant config
 * Falls back to /logo.webp if config is not loaded or logo is not set
 */
export function TenantLogo({ 
  className = "h-12 w-auto", 
  fallbackSrc = "/logo.webp" 
}: TenantLogoProps) {
  const { data: config } = trpc.config.getTenantConfig.useQuery(undefined, {
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
  
  const logoSrc = config?.branding?.logo || fallbackSrc;
  const altText = config?.tenantName || "Logo";
  
  return (
    <img 
      src={logoSrc} 
      alt={altText} 
      className={className}
    />
  );
}
